export default __webpack_public_path__ + "static/media/romatherapy-summer-cobb-salad.2d531bea.jpg";